module.exports = __webpack_public_path__ + "static/bg-video-944c97601ea659c23755ef58c9ee6f96.mp4";